import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import Api from '../api/Api';
import { MUTATION_KEYS } from './queryKeys';

type GetSampleDataVariables = {
  datasetAcronym: string;
};

export default function useGetSampleDataMutation({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: string) => void;
  onError?: () => void;
}) {
  return useMutation({
    mutationKey: [MUTATION_KEYS.cart.getSampleData],
    mutationFn: async ({ datasetAcronym }: GetSampleDataVariables) => {
      return await Api.moodV2Order.getSampleDataLink(datasetAcronym);
    },
    onSuccess: (data) => onSuccess?.(data.Result),
    onError: (error: unknown) => {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      message.error(errorMessage);
      onError?.();
    },
  });
}
